import React, { useState } from "react";
import { Row, Col, Breadcrumb, Card, Table } from 'react-bootstrap';
import { Button } from "primereact/button";
import { Link } from "react-router-dom";
import '../../assets/css/brandbook.css';
import { Sidebar } from 'primereact/sidebar';
import { useNavigate } from 'react-router-dom';

const Post_datasheet = () => {
    const [expandedRow, setExpandedRow] = useState(null);
    const [visibleRight, setVisibleRight] = useState(false);
    const navigate = useNavigate();
    const data = [
        { id: 1, name: "John Doe", age: 28, email: "john@example.com", details: "More info about John" },
        { id: 2, name: "Jane Smith", age: 32, email: "jane@example.com", details: "More info about Jane" },
        { id: 3, name: "Sam Brown", age: 40, email: "sam@example.com", details: "More info about Sam" }
    ];

    const toggleRow = (id) => {
        setExpandedRow(expandedRow === id ? null : id);
    };


  return (
    <>
      <Row className="body_content">
        <Row className="mx-0">
            <Col lg={12} className="mb-4 d-flex justify-content-between align-items-center">
                <Breadcrumb>
                    <Breadcrumb.Item onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
                        <i className="pi pi-angle-left"></i> Back
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>Post Data Sheet</Breadcrumb.Item>
                </Breadcrumb>
                <div>
                    <Button 
                        severity="info"
                        label="Download Excel"
                        icon="pi pi-file-excel"
                        className="py-2 border-0 ms-2"
                    />
                </div>
                
            </Col>
            <Col lg={12} className="bg-white p-2">
                <div className="table-responsive postdetTable">
                    <Table size="sm"  bordered >
                        <thead className="table-primary">
                            <tr>
                                <th style={{width: '60px'}}></th>
                                <th>Day</th>
                                <th>Post Type</th>
                                <th>Topic</th>
                                <th>Visual Idea + Reference</th>
                                <th>Copy</th>
                                <th>Caption</th>
                                <th>Keywords + Hashtags</th>
                                <th style={{width: '60px'}}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item) => (
                                <React.Fragment key={item.id}>
                                    <tr>
                                        <td>
                                            <Button 
                                                severity="danger" 
                                                text
                                                icon={expandedRow === item.id ? "pi pi-minus" : "pi pi-plus"} 
                                                className="p-0 border-0"
                                                onClick={() => toggleRow(item.id)}
                                            />
                                        </td>
                                        <td className="text-black">
                                            10/03/2025
                                            <small className="d-block">Monday</small>
                                        </td>
                                        <td>Carousel</td>
                                        <td>Occasional - Valentine's Day</td>
                                        <td>Paddle reflection as a heart</td>
                                        <td>
                                        Match Made in Heaven. #ValentinesDay
                                        </td>
                                        <td>
                                            Split image with two sides:
                                            On the left: A playful, lighthearted Bumble profile with hearts.
                                            On the right: A powerful image of someone smashing a pickleball with a Grytskill paddle
                                        </td>
                                        <td>
                                        Matching for Others vs. Matching for Picklers #ValentinesDay
                                        </td>
                                        <td>
                                            <Button 
                                                severity="help" 
                                                text
                                                icon="pi pi-pen-to-square"
                                                className="p-0 border-0"
                                                onClick={() => setVisibleRight(true)}
                                            />
                                        </td>
                                    </tr>
                                    {expandedRow === item.id && (
                                        <tr>
                                            <td colSpan="9" className="bg-white">
                                                <div className="posttimeline">
                                                    <ul className="timeline-list">
                                                        <li>
                                                            <div className="timeline_content">
                                                                <h4>Internal Feedback</h4>
                                                                <span> <small>10/03/2025 | 10:00 AM</small></span>
                                                                <p>We gather your business and products information. We then determine the direction of the project and understand your goals and we combine your ideas with ours for an amazing website.</p>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="timeline_content">
                                                                <h4>Client Feedback</h4>
                                                                <span> <small>10/03/2025 | 13:00 PM</small></span>
                                                                <p>We gather your business and products information. We then determine the direction of the project </p>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </Col>
        </Row>
      </Row>

        <Sidebar visible={visibleRight} position="right" onHide={() => setVisibleRight(false)} style={{ width: '30vw' }}>
            <Card className="p-0 shadow-0">
                <Card.Header className="px-0 pt-0 pb-0">
                    <h6 className="text-black mb-0">Brand Name</h6>
                    <p className="text-primary"><small>Date: 10/03/2025</small></p>
                </Card.Header>
                <Card.Body className="p-0">

                </Card.Body>
                <Card.Footer className="border-0">

                </Card.Footer>
            </Card>
            
            <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
                Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </p>
        </Sidebar>
    </>
  );
};

export default Post_datasheet;